var stars = $('#rating .ratingStars');

stars.hover(
  function () {
    var $this = $(this);
    $this.prevAll().addBack().addClass('hoverStars');
  },
  function () {
    var $this = $(this);
    $this.prevAll().addBack().removeClass('hoverStars');
  });

stars.on('click', function () {
  var $this = $(this);

  // if you click the highest star that is already selected, deselect all stars
  if ($this.hasClass('clickStars') && !$this.next().hasClass('clickStars')) {
    $this.removeClass('clickStars');
    $this.siblings().removeClass('clickStars');
    $this.parents('form').find('input[name="rating"]').val('');
  } else {
    $this.siblings().removeClass('clickStars')
    $this.prevAll().addBack().addClass('clickStars');
    $this.parents('form').find('input[name="rating"]').val($this.index() + 1);
  }
});